import { render, staticRenderFns } from "./diningdetail.vue?vue&type=template&id=117d069c&scoped=true&"
import script from "./diningdetail.vue?vue&type=script&lang=js&"
export * from "./diningdetail.vue?vue&type=script&lang=js&"
import style0 from "./diningdetail.vue?vue&type=style&index=0&id=117d069c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117d069c",
  null
  
)

export default component.exports